<topo-modal
  [isActive]="isActive"
  [isCard]="true"
  [rawWidth]="!isDesktop && '90%'"
  [showLoadingOverlay]="isLoading()">
  <div class="modal-header">
    <div
      class="mx-4 my-4"
      fxLayout="row"
      fxLayoutAlign="space-between">
      <div>
        <h5>{{ 'NOTIFICATION-PREFERENCES.REGISTER-EMAIL-ADDRESS' | translate }}</h5>
      </div>
      <div>
        <div
          class="dialog-close"
          (click)="cancelEmail()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-body">
    <form [formGroup]="form">
      @if (!(enterCode$ | async)) {
        <div
          [ngStyle]="{ 'display': !(showEnterCode$ | async) ? 'block' : 'none' }"
          fxLayout="column"
          fxLayoutAlign="space-between center"
          style="width: 100%">
          <div
            fxLayout="column"
            fxLayoutAlign="space-between center"
            style="width: 100%">
            <div
              fxLayout="row"
              fxLayoutAlign="center center">
              <img
                class="light-topo"
                src="/assets/images/topoone-by-crisis24.svg" />
              <img
                class="dark-topo"
                src="/assets/images/topoone-by-crisis24-white.svg" />
            </div>
            <div class="mt-5">{{ 'NOTIFICATION-PREFERENCES.REGISTER-EMAIL-ADDRESS-DESC' | translate }}</div>
          </div>
          <div
            fxLayout="column"
            fxLayoutAlign="space-around center"
            style="width: 100%">
            <input
              class="input mt-5 mb-1"
              [class.is-error]="!!error"
              type="text"
              placeholder="{{ 'NOTIFICATION-PREFERENCES.EMAIL-ADDRESS' | translate }}"
              formControlName="email"
              style="width: 100%" />
            @if (!!error) {
              <topo-notification-banner
                type="error"
                class="mt-5"
                style="width: 100%">
                {{ error | translate }}
              </topo-notification-banner>
            }
          </div>
          <button
            class="button is-fullwidth is-primary is-small mt-5"
            (click)="requestCodeClick()">
            {{ 'NOTIFICATION-PREFERENCES.BUTTON-REQUEST-CODE' | translate }}
          </button>
        </div>
      }

      @if (enterCode$ | async) {
        <div
          [ngStyle]="{ 'display': !(showEnterCode$ | async) ? 'block' : 'none' }"
          fxLayout="column"
          fxLayoutAlign="space-between center"
          style="width: 100%">
          <div
            fxLayout="column"
            fxLayoutAlign="space-between center"
            style="width: 100%">
            <div
              fxLayout="row"
              fxLayoutAlign="center center">
              <img
                class="light-topo"
                src="/assets/images/topoone-by-crisis24.svg" />
              <img
                class="dark-topo"
                src="/assets/images/topoone-by-crisis24-white.svg" />
            </div>
            <div class="mt-5">{{ 'NOTIFICATION-PREFERENCES.REGISTER-EMAIL-ADDRESS-DESC-2' | translate }}</div>
          </div>
          <div
            fxLayout="column"
            fxLayoutAlign="space-around center"
            style="width: 100%">
            <input
              class="input mt-5 mb-1"
              [class.is-error]="!!error"
              type="text"
              placeholder="{{ 'NOTIFICATION-PREFERENCES.ENTER-CODE' | translate }}"
              formControlName="code"
              style="width: 100%" />
          </div>
          @if (!!error) {
            <topo-notification-banner
              type="error"
              class="mt-5"
              style="width: 100%">
              {{ error | translate }}
            </topo-notification-banner>
          }
          <button
            [disabled]="!form.value.code"
            class="button is-fullwidth is-primary is-small mt-5"
            style="width: 100%"
            (click)="verifyCode()">
            {{ 'NOTIFICATION-PREFERENCES.BUTTON-VERIFY-CODE' | translate }}
          </button>
        </div>
      }
    </form>
  </div>

  <div class="modal-footer">
    <div
      fxLayout="row"
      fxLayoutAlign="end">
      <button
        class="button is-secondary is-small"
        style="min-width: 75px"
        (click)="cancelEmail()">
        {{ 'NOTIFICATION-PREFERENCES.BUTTON-CANCEL' | translate }}
      </button>
    </div>
  </div>
</topo-modal>
